import React from "react";
import OrderListComponent from "../../../components/StoreModule/Order/orderlist.component";

export default class OrderList extends React.Component {
  render() {
    return <OrderListComponent />;
  }
}
